import React from "react";
import { Row, Col, Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Navbar from "../../../layouts/Navbar";
import Sidebar from "../../../layouts/Sidebar";
import Orange from "../../../assets/images/qu.svg";
import PreviewTemplate from "./PreviewTemplate";
import { getIgnoreFields, getQutationTemplates, clearSingleCustomer, clearValues } from "../../../actions";
const authRole = localStorage.getItem('userRole');

class SelectTemplate extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      templates: [],
      show: false,
      temp: [],
      allData: []
    }
    this.clickHandler = this.clickHandler.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleShow = this.handleShow.bind(this);
  }
  componentDidMount() {
    this.props.dispatch(getQutationTemplates());
  }
  componentDidUpdate(prevProps) {
    if (prevProps.quotationTemplates !== this.props.quotationTemplates) {
      // Ensure quotationTemplates is an array before calling filter
      if (Array.isArray(this.props.quotationTemplates)) {
        const temp = this.props.quotationTemplates.filter((item, i) => {
          if (i < 4) {
            return item;
          }
        });
        this.setState({
          templates: temp,
          allData: this.props.quotationTemplates
        });
      } else {
        // If quotationTemplates is not an array, set empty arrays
        this.setState({
          templates: [],
          allData: []
        });
      }
    }
    localStorage.removeItem("newQuotation");
  }
  handleShow(item) {
    if (item) {
      this.setState({
        show: true,
        temp: item
      })
    }
  }
  handleClose() {
    this.setState({
      show: false
    })
  }
  clickHandler(item) {
    if (item && item.templateId) {
      this.props.dispatch(clearSingleCustomer());
      this.props.dispatch(clearValues());
      window.location.hash = `${authRole}/quotations/create-quotation/customerDetails/${item.templateId}/null`;
    }
  }

  render() {
    const { templates, show, temp, allData } = this.state;
    return (
      <div>
        <Navbar />
        <div className="dashboard-page">
          <div className="dashboard-sidebar">
            <Sidebar />
          </div>
          <div className="dashboard-main">
            <Card className="staff-page">
              <img src={Orange} alt="..." className="head-img" />
              {localStorage.getItem("fromPage") === "quotations" ? <h5 className='po_link' onClick={() => window.location.hash = "/" + authRole + "/quotations"}>Quotations</h5> : <h5 className='po_link' onClick={() => window.location.hash = "/" + authRole + "/quotations/workspace"}>Work Space</h5>}
              <i className="fas fa-arrow-right crt"></i>
              <h6>Select Template</h6>
              <Row className="template">
                {Array.isArray(templates) && templates.map((item, i) => (
                  <div key={i}>
                    <Card className="template-card">
                      <img src={item.templateSampleUrl} onClick={() => this.handleShow(item)} width="230px" />
                      <p>{item.templateName}</p>
                      <button className="select-template" onClick={() => this.clickHandler(item)}>
                        Select Template
                      </button>
                    </Card>
                  </div>
                ))}
                {this.props.loading ? "" :
                  Array.isArray(allData) && allData[5] ? (
                    <div>
                      <Card className="template-card">
                        <img src={allData[5].templateSampleUrl} onClick={() => this.handleShow(allData[5])} width="230px" />
                        <p>{allData[5].templateName}</p>
                        <button className="select-template" onClick={() => this.clickHandler(allData[5])}>
                          Select Template
                        </button>
                      </Card>
                    </div>
                  ) : null}
              </Row>
            </Card>
          </div>
        </div>
        <PreviewTemplate title={temp?.templateName} authRole={authRole} templateId={temp?.templateId} temp={temp?.templateSampleUrl} show={show} onHide={this.handleClose} />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    loading: state.qutation.loading,
    quotationTemplates: state.qutation.quotationTemplates
  }
}

export default connect(mapStateToProps)(SelectTemplate);